import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Body } from '@sorare/core/src/atoms/layout/Body';
import { useSeoContext } from '@sorare/core/src/contexts/seo';
import { useQueryString } from '@sorare/core/src/hooks/useQueryString';

import { About } from './About/index.tsx';
import { BuildYourCareer } from './BuildYourCareer/index.tsx';
import { Careers as CareersSection } from './Careers/index.tsx';
import { History } from './History/index.tsx';
import { JobBoard } from './JobBoard/index.tsx';
import { JobForm } from './JobForm/index.tsx';
import { LifeAtSorare } from './Life/index.tsx';
import { Mission } from './Mission/index.tsx';
import { Stakeholders } from './Stakeholders/index.tsx';
import { Values } from './Values/index.tsx';
import type { Job } from './types.ts';

const InnerBody = styled.div`
  max-width: 2200px;
  margin: auto;
`;

export const Careers = () => {
  const { setPageMetadata } = useSeoContext();

  const jid = useQueryString('jid');

  const [jobs, setJobs] = useState<Job[]>([]);

  useEffect(() => setPageMetadata('Careers'), [setPageMetadata]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          'https://api.ashbyhq.com/posting-api/job-board/sorare?includeCompensation=true'
        );
        const data = await response.json();
        setJobs(data.jobs as Job[]);
      } catch {
        setJobs([]);
      }
    };

    fetchData();
  }, []);

  const job = jobs.find(j => j.id === jid);

  return (
    <Body>
      <InnerBody>
        <CareersSection />
        {job ? (
          <JobForm job={job} />
        ) : (
          <>
            <About />
            <History />
            <Stakeholders />
            <Mission />
            <BuildYourCareer />
            <LifeAtSorare />
            <Values />
            <div id="jobs">
              <JobBoard jobs={jobs} />
            </div>
          </>
        )}
      </InnerBody>
    </Body>
  );
};
